import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/cookieBanner.scss";

const NOTICE_KEY = "jskerandcoCookieNotice";

function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(!localStorage.getItem(NOTICE_KEY));
    } catch {
      setVisible(true);
    }
  }, []);

  const rememberChoice = (choice) => {
    try {
      localStorage.setItem(NOTICE_KEY, choice);
    } catch {
      // The notice can still be closed when browser storage is unavailable.
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <section className="cookie-banner" aria-label="Cookie and storage notice">
      <div className="cookie-banner__copy">
        <strong>Cookie &amp; storage notice</strong>
        <p>
          We use necessary browser storage to keep your shopping bag and
          remember this notice. We do not currently use advertising or
          analytics cookies. <Link to="/cookies">Read the Cookie Policy</Link>.
        </p>
      </div>
      <div className="cookie-banner__actions">
        <button type="button" onClick={() => rememberChoice("necessary")}>
          Use necessary storage
        </button>
        <button
          type="button"
          className="cookie-banner__secondary"
          onClick={() => rememberChoice("dismissed")}
        >
          Close notice
        </button>
      </div>
    </section>
  );
}

export default CookieBanner;
